/**
 * システム管理API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 郵便番号より取得する住所情報
 */
export interface AddressSearchInfoToZipCodeDto { 
    /**
     * 住所コード
     */
    addressCode?: string;
    /**
     * 都道府県名称
     */
    prefecturesName?: string;
    /**
     * 市区郡町村名称
     */
    cityName?: string;
    /**
     * 町域名称
     */
    townAreaName?: string;
    /**
     * 大字丁目名称
     */
    ooazaName?: string;
    /**
     * 都道府県カナ名称
     */
    prefecturesNameKana?: string;
    /**
     * 市区郡町村カナ名
     */
    cityNameKana?: string;
    /**
     * 町域カナ名称
     */
    townAreaNameKana?: string;
    /**
     * 町カナ名
     */
    ooazaNameKana?: string;
}

